import { Helmet, HelmetData } from "react-helmet-async";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router-dom";
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { client } from "../../../client";
import { AI_BG_NEW } from "../../../assets";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
const helmetData = new HelmetData({});

export default function SingleBlogNew() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [allPosts, setAllPosts] = useState([]);
  const [relatedPosts, setRelatedPosts] = useState(null);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "Title"]{
      title,
      author,
      body,
      author_avatar,
      cover_photo,
      tags,
      published_date,
      featured_post,
      id,
      is_global,
      news
    }`
      )
      .then((data) => {
        setPost(data.filter((d) => d.is_global && d.id == id)[0]);
        setAllPosts(data.filter((d) => d.is_global && !d.news));
      });
  }, [id]);
  const match = (array1, arraysObj) => {
    const arrays = Object.values(arraysObj);
    return arrays.filter((arr) =>
      arr.tags.some((element) => array1.includes(element))
    );
  };
  useEffect(() => {
    if (allPosts && post) {
      const related = match(post.tags, allPosts);
      setRelatedPosts(related);
    }
  }, [allPosts, post]);

  const plainBody = post?.body
    ? post.body
        .replace(/[#*_>`~[\]()!-]/g, " ")
        .replace(/\s+/g, " ")
        .trim()
    : "";
  const words = plainBody ? plainBody.split(" ") : [];
  const metaDescription =
    words.slice(0, 28).join(" ") + (words.length > 28 ? "…" : "");
  const postUrl = `https://analyticsintelligence.com/blog/${id}`;
  const ogImage =
    post?.cover_photo || "https://analyticsintelligence.com/favicon.png";
  const postKeywords = Array.isArray(post?.tags) ? post.tags.join(", ") : "";

  return (
    <>
      {post && (
        <Helmet helmetData={helmetData}>
          <title>{`${post.title} | Analytics Intelligence`}</title>
          <meta name="description" content={metaDescription} />
          {postKeywords && <meta name="keywords" content={postKeywords} />}
          <meta name="robots" content="index, follow" />
          <meta name="author" content={post.author || "Analytics Intelligence Ltd"} />
          <link rel="canonical" href={postUrl} />
          <meta property="og:title" content={post.title} />
          <meta property="og:description" content={metaDescription} />
          <meta property="og:image" content={ogImage} />
          <meta property="og:type" content="article" />
          <meta property="og:url" content={postUrl} />
          <meta property="og:site_name" content="Analytics Intelligence" />
          <meta property="og:locale" content="en_GB" />
          {post.published_date && (
            <meta property="article:published_time" content={post.published_date} />
          )}
          {post.author && (
            <meta property="article:author" content={post.author} />
          )}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@_AnalyticsIntel" />
          <meta name="twitter:title" content={post.title} />
          <meta name="twitter:description" content={metaDescription} />
          <meta name="twitter:image" content={ogImage} />
        </Helmet>
      )}
      <main className="">
        <section
          style={{
            backgroundImage: `url("${AI_BG_NEW}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          className="lg:min-h-[95vh] flex items-center"
        >
          <div className="container mx-auto w-full h-full flex flex-col gap-16 pt-[96px] md:pt-[15rem] pb-[96px]">
            {post && (
              <img
                src={post.cover_photo}
                alt="blogimage"
                className="rounded-lg h-[307px] w-[408px] md:w-auto md:h-auto object-cover"
              />
            )}
          </div>
        </section>

        {post && (
          <div className="container relative flex flex-col text-white pb-[96px] w-full max-w-[856px] mx-auto px-1">
            {/* <div className="w-[150px] lg:w-[700px] h-[700px] bg-[#0073FF]/30 blur-[120px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] -z-50"></div> */}
            <div className="flex items-center justify-between  md:gap-[16px] md:mb-11">
              <div className="flex items-center gap-3">
                <img
                  className="object-cover rounded-[50%] h-[48px] w-[48px] border border-[#01ADFF]"
                  src={post.author_avatar}
                  alt="avatar"
                />
                <div className="flex flex-col justify-between">
                  <span>{post.author}</span>
                </div>
              </div>

              <div className="flex items-start gap-2">
                <CalendarTodayOutlinedIcon
                  fontSize="small"
                  className="text-white"
                />
                <p>
                  {new Intl.DateTimeFormat("en-GB", {
                    weekday: "long",
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })
                    .format(new Date(post.published_date))
                    .replace(/^(\w+)\s/, "$1, ")}
                </p>
              </div>
            </div>
            <h1 className="text-[24px] sm:text-[32px] mt-5 md:mt-[33px] leading-[150%] font-bold font-manrope text-white">
              {post.title}
            </h1>
            <div className=" flex flex-col mt-6 md:mt-[44px] pb-[150px] gap-[20px] text-white">
              <div className=" body flex flex-col justify-center md:mx-auto  leading-[30px] blurry font-manrope ">
                <ReactMarkdown children={post.body} className="markdown [&_p]:!text-sm md:[&_p]:!text-base !p-0 [&_ul]:!p-0 [&_ul]:!text-sm md:[&_ul]:!text-base &_ol]:!text-sm md:[&_ol]:!text-base &_ul]:!text-sm [&_ol]:!p-0 md:[&_ol]:!pl-xl" />
              </div>
              <div className="flex flex-col gap-[15px] md:w-[30%]">
                <h1 className="text-[18px] font-bold">Share</h1>
                <div className="flex gap-[10px]">
                  <FacebookShareButton
                    url={window.location.href}
                    quote={post.title}
                  >
                    <FacebookIcon size={50} />
                  </FacebookShareButton>
                  <TwitterShareButton
                    url={window.location.href}
                    title={post.title}
                  >
                    <TwitterIcon size={50} />
                  </TwitterShareButton>
                  <WhatsappShareButton
                    url={window.location.href}
                    title={post.title}
                  >
                    <WhatsappIcon size={50} />
                  </WhatsappShareButton>
                  <TelegramShareButton
                    url={window.location.href}
                    title={post.title}
                  >
                    <TelegramIcon size={50} />
                  </TelegramShareButton>
                </div>
              </div>
            </div>
            {relatedPosts &&
              relatedPosts.filter((p) => p.id != id).length > 0 && (
                <h1 className="text-[24px] mb-5 md:mb-[44px] text-center text-white font-extrabold leading-[150%]">
                  Related Article
                </h1>
              )}
            <div className="flex flex-wrap gap-[28px]">
              {relatedPosts &&
                relatedPosts.slice(0, 4).map((p) =>
                  p.id != post.id ? (
                    <div
                      className="lg:w-[33%] md:w-[48%] max-w-[400px] w-full mx-auto flex flex-col gap-4 p-6 rounded-xl bg-[#FFFFFF0F] flex-shrink-0"
                      key={p?.id}
                    >
                      <div>
                        <img
                          src={p.cover_photo}
                          alt="blog"
                          className="object-cover h-[200px] w-full rounded-lg"
                        />
                      </div>
                      <div className="flex justify-between">
                        <div className="flex items-center gap-2">
                          <div className="overflow-hidden rounded-full border-2 border-white">
                            <img
                              src={p.author_avatar}
                              alt="avatar"
                              className="w-6 h-6"
                            />
                          </div>
                          <span className="text-white text-sm">{p.author}</span>
                        </div>

                        <div className="flex items-center gap-2">
                          <CalendarTodayOutlinedIcon
                            fontSize="small"
                            className="text-white"
                          />
                          <p className="text-white text-sm">
                            {new Intl.DateTimeFormat("en-GB", {
                              weekday: "long",
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            })
                              .format(new Date(p.published_date))
                              .replace(/^(\w+)\s/, "$1, ")}
                          </p>
                        </div>
                      </div>

                      <div className="space-y-2">
                        <h1 className="text-white text-[18px] leading-[150%] font-bold">
                          {p.title}
                        </h1>

                        <p className="text-[#C0C0C0] text-sm leading-[150%]">
                          {p.body.slice(0, 100)}....
                        </p>
                      </div>

                      <Link
                        to={`/blog/${p.id}`}
                        className="text-white text-[12px] font-[500] leading-[150%] w-max self-baseline justify-self-end"
                      >
                        <button className="text-sm font-semibold py-1.5 px-4 text-center btn-sweep btn-sweep-blue text-white rounded-[100px] gap-2">
                          Read Now
                        </button>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )
                )}
            </div>

            <style jsx="true">{`
              .swiper-button-next,
              .swiper-button-prev {
                color: #000;
              }
              .swiper-pagination-bullet-active {
                background-color: #000;
              }
              .body p {
                margin-bottom: 20px;
                color: rgba(255, 255, 255, 0.8);
                font-family: Manrope;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 30px;
              }
              .body h2 {
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 20px;
              }
              .body img {
                display: flex;
                justify-content: center;
                align-item: center;
                margin: 20px auto;
              }
              .body a:hover {
                color: #0073ff;
              }
              .body a {
                text-decoration: underline;
              }
              .brand {
                height: 200px;
                width: 100%;
                object-fit: cover;
              }
              .speakers-header {
                font-weight: 500;
                text-transform: uppercase;
                margin-top: 1rem;
                color: #555;
                margin-bottom: 1rem;
              }
              .profile {
                display: flex;
                align-items: center;
                margin-bottom: 1.5rem;
              }
              .profile img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                object-fit: cover;
                margin-right: 1rem;
              }
              .profile h5 {
                font-size: 0.9rem;
              }
              .profile h6 {
                font-size: 0.8rem;
                font-weight: normal;
              }

              .other {
                text-align: center;
              }
              .banner .title {
                margin-bottom: 2rem;
                color: rgba(31, 53, 105, 1);
              }

              .card-base .content {
                padding: 0px;
                margin-top: 2rem;
                width: 100%;
                box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
                background-color: #fff;
                overflow: hidden;
              }

              .text-body {
                color: #000;
              }
              .text-body .btn-base {
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 1rem;
              }

              .card-base {
                display: flex;
                flex-direction: column;
                align-items: center;
              }

              .card-base h4 {
                font-size: 1.2rem;
                font-weight: 600;

                margin-bottom: 1rem;
              }
              .card-base a {
                color: inherit;
                text-decoration: none;
              }
              .card-base p {
                margin-top: 1rem;
                margin-bottom: 1rem;
              }

              .products {
                background-color: #fff;
                padding-top: 5rem;
                padding-bottom: 5rem;
                color: #1f3569;
              }
              .deliver {
                padding-top: 3rem;
                padding-bottom: 3rem;
              }
              .both {
                display: grid;
                grid-template-columns: 3fr 2fr;
                align-items: center;
                justify-content: center;
              }
              .both-media {
                padding: 2rem;
              }

              @media only screen and (max-width: 800px) {
                .both {
                  grid-template-columns: 1fr;
                }
              }
              .both-text p {
                font-size: 1.3rem;
              }
              .deliver h2 {
                margin-bottom: 1rem;
                font-size: 1.9rem;
              }
              .banner {
                margin-top: 85px;
                background: linear-gradient(
                    to bottom,
                    rgba(0, 0, 0, 0.8),
                    rgba(0, 0, 0, 0.8)
                  ),
                  url(${post.cover_photo});
                padding-top: min(8rem, 10vw);
                padding-bottom: min(10rem, 15vw);
                background-repeat: no-repeat;
                background-size: cover;
                background-position: 25%;
                color: #fff;
              }
              .house {
                max-width: 700px;
              }
              .house p {
                font-size: 1rem;
                margin-top: 1rem;
                margin-bottom: 1rem;
              }
              .btn-group button {
                padding: 1rem 4rem;
                margin-bottom: 1rem;
                font-size: 1.2rem;
              }
              .btn-group .btn-white {
                margin-right: 1rem;
              }
              .btn-base {
                padding: 1rem 3rem;
                margin-bottom: 1rem;
                font-size: 1.1rem;
                margin-top: 1rem;
              }
            `}</style>
          </div>
        )}
      </main>
    </>
  );
}
